import { PrintMap } from "esdm-map/dist/map/tools/PrintMap";
import { IPrintOptions } from "esdm-map/dist/map/tools/IPrintOptions";
import { DownloadMapPng } from "esdm-map/dist/map/tools/DownloadMapPng";
import { IMapViewStore } from "esdm-map/dist/map/store/IMapViewStore";
import { IVectorLayerGroupFactory } from "esdm-map/dist/layers/groups/vector/interfaces/IVectorLayerGroupFactory";
import { IMapContextMenu } from "esdm-map/dist/map/tools/IMapContextMenu";
import { IFeatureLoader } from "esdm-map/dist/layers/vector/sources/loaders/interfaces/IFeatureLoader";
import { OgcMapFilter } from "esdm-map/dist/map/filters/OgcMapFilter";
import { VectorLayerGroupFactory } from "esdm-map/dist/layers/groups/vector/VectorLayerGroupFactory";
import { MapViewStore } from "esdm-map/dist/map/store/MapViewStore";
import { MapContextMenu } from "esdm-map/dist/map/tools/MapContextMenu";
import { ToolTipProvider } from "esdm-map/dist/map/tooltip/ToolTipProvider";
import { IVectorLayerGroupConfig } from "esdm-map/dist/layers/groups/vector/interfaces/IVectorLayerGroupConfig";
import { GeoJsonFeatureLoader } from "esdm-map/dist/layers/vector/sources/loaders/GeoJsonFeatureLoader";
import { ILoaderExtentsBehaviour } from "esdm-map/dist/layers/vector/sources/loaders/behaviours/ILoaderExtentsBehaviour";
import { BoundsLoaderExtentsBehaviour } from "esdm-map/dist/layers/vector/sources/loaders/behaviours/BoundsLoaderBehaviour";
import { IFeatureAdd } from "esdm-map/dist/layers/vector/sources/loaders/interfaces/IFeatureAdd";
import { FeatureAdd } from "esdm-map/dist/layers/vector/sources/loaders/FeatureAdd";
import { ExtentsNavigation } from "esdm-map/dist/map/controls/ExtentsNavigation";
import { LayerGroupFactory } from "esdm-map/dist/layers/groups/LayerGroupFactory";
import { LayerGroupCollection } from "esdm-map/dist/layers/groups/LayerGroupCollection";
import { MapFilters } from "esdm-map/dist/map/filters/MapFilters";
import { GridRef } from "esdm-map/dist/map/controls/GridRef";

import { IMappingTextPack } from "esdm-map/dist/resources/MappingTextPack";
import { MousePosition } from "esdm-map/dist/map/controls/MousePosition";

import { IStyleFactory } from "esdm-map/dist/layers/vector/styles/IStyleFactory";
import { IVectorLayerSourceFactory } from "esdm-map/dist/layers/vector/sources/interfaces";
import { VectorLayerSourceFactory } from "esdm-map/dist/layers/vector/sources";
import { IBaseLayerFactory } from "esdm-map/dist/baselayers/interfaces/IBaseLayerFactory";
import { CustomMapLayerSwitcherOverlays } from "./CustomMapLayerSwitcherOverlays";
import { IVectorLayerGroup } from "esdm-map/dist/layers/groups/vector/interfaces/IVectorLayerGroup";
import { ZoomToDataBounds } from "esdm-map/dist/layers/vector/ZoomToDataBounds";
import { VectorLayerStrategy } from "esdm-map/dist/layers/vector/VectorLayerStrategy";
import { WfsParamSourceMapServer } from "esdm-map/dist/layers/vector/sources/wfs";
import {
    MapOptions,
    IMap,
    MapLayerSwitcher,
    IMapAreaMask,
    ILogger,
    IResourceFactory,
    IMapFactory,
    BaseLayerFactory_3857,
    MapFactory,
    Logger,
    BaseLayerType,
    MiniMapsForLists,

    MapFeatureInfo
} from "esdm-map";

import { HbsmrStyleFactory } from "./HbsmrStyleFactory";
import { HbsmrResourcefactory } from "./HbsmrResourceFactory";
import { NorthamptonshireRecordType, NorthamptonshireRecordSubType } from "./NorthantsRecordTypes";
import { DefaultLayerConfigurationFactory } from "./DefaultLayerConfigurationFactory";
import { NorthantsHerBoundary } from "./NorthantsHerBoundary";
import { DefaultMapOptions } from "./DefaultMapOptions";
import { TextPacks, TextPackLoader } from "./TextPackLoader";
import { MapBase } from "./MapBase";
import { HbsmrUser, HbsmrIdentity } from "./HbsmrUser";
import { IlayerGroupCollectionConfig } from "esdm-map/dist/layers/groups/IlayerGroupCollectionConfig";
import { LayerGroupCollections } from "esdm-map/dist/layers/groups/LayerGroupCollections";
import { NorthantsBaseLayerTypes, NorthantsBaseMapping_3857 } from "./NorthantsBaseMapping_3857";
import { MapToolTip, ToolTipOptions } from "esdm-map/dist/map/tooltip";
import { debounce } from "debounce";
import { FeatureAddSmallGeomsAsPoint } from "esdm-map/dist/layers/vector/sources/loaders";
//import { OsOpenNames } from "esdm-map/dist/gazetteer/os/OsOpenNames";
import { GeoNames } from "esdm-map/dist/gazetteer/geonames";
import Style from "ol/style/Style";
import Fill from "ol/style/Fill";
import TextStyle from "ol/style/Text";

$(function () {
    let didLoadMap = false;

    let ele = $("#theMap"); 
    let maxFeatureCount: number = <number>ele.data("max-feature-count");

    let data = $("#searchMapData");
    let searchString: string = <string>data.data("search-string");
    let searchMode: string = <string>data.data("search-mode");
 
    let printOptions: PrintMap =  new PrintMap();

    if (!printOptions.isPrintMap) {              
        window.addEventListener('resize', debounce(resizeMap, 250));  
    } 
    let searchMap: SearchMap;
    let loadMap = function () {
        HbsmrIdentity.fetch().then(function (e) {
            let user = e;
            let init = function (textpacks: TextPacks) {
                searchMap = new SearchMap("theMap", searchString, searchMode, maxFeatureCount, printOptions, textpacks.mapping, user);
                didLoadMap = true;
            }
            TextPackLoader.load().then(init);
        });        
    }

    function resizeMap() {        
        var height = $(window).height() - $("#mapContainer").offset().top;
        if (height <= 500) {
            height = 500;
        }
        $('#mapContainer').height(height);

        if (searchMap) {
            searchMap.map.olMap.updateSize();
        }
    };

    if (printOptions.isPrintMap) {       
        loadMap();
    }
    else {
        let bingAPIKey: string = ele.data("bing-api-key");
        let esdmOsmApiKey: string = ele.data("esdm-osm-api-key");   
        let baseLayerFactory: IBaseLayerFactory = new NorthantsBaseMapping_3857();        
        let miniMaps = new MiniMapsForLists(NorthantsBaseLayerTypes.NorthamptonshireOS, bingAPIKey, esdmOsmApiKey, baseLayerFactory, "EPSG:27700", "EPSG:3857");
               
        //only show the map when the map tab is visible
        $('a[data-bs-toggle="tab"]').on('shown.bs.tab', function (e) {
            let target = $(e.target).attr("href") // activated tab
            if (target === "#tabMap") {
                if (didLoadMap === false) {
                    resizeMap();
                    loadMap();
                }
            } else if (target === "#tabList" && didLoadMap === true) {
                // If the map has loaded it means the user has visited the 'Map' tab, they could have possibly also put the map into fullscreen mode
                // if they have then we need to redraw/refresh the miniMaps on the search results list, as they don't refresh correctly after exiting
                // the fullscreen mode
                miniMaps.refreshMiniMaps();
            }
        });
    }
});

export class SearchMap extends MapBase {

    public map: IMap;
    private mfOptions: MapOptions;
    private mapStore: IMapViewStore;
    private styleFactory: IStyleFactory;
    private ls: MapLayerSwitcher;
    private vectorLayerGroups: Array<IVectorLayerGroup>;
    private infoPopup: MapFeatureInfo;
    private initialised = false;
    private herMask: IMapAreaMask;
    //private osOpenNames: OsOpenNames;
    private geoNames: GeoNames;
    private logger: ILogger;
    private vectorLayerSourceFactory: IVectorLayerSourceFactory;
    private baseLayerFactory: IBaseLayerFactory;
    private mapFactory: IMapFactory;
    private vectorLayerGroupFactory: IVectorLayerGroupFactory;
    private boundsLoaderBehaviour: ILoaderExtentsBehaviour;
    private mapContextMenu: IMapContextMenu;
    private resourcefactory: IResourceFactory;
    private downloadPng: DownloadMapPng;
    private extentsNavigation: ExtentsNavigation;
    private gridRefFinder: GridRef;
    private mousePosition: MousePosition;
    private featureLoader: IFeatureLoader;
    private featureAdd: IFeatureAdd;
    private mapFilter: MapFilters;
    private layerConfigFactory: DefaultLayerConfigurationFactory;
    private layerGroups: LayerGroupCollections;
    private layerGroupFactory: LayerGroupFactory;
    private mapToolTip: MapToolTip;

    constructor(
        private _mapElementId: string,     
        private _searchString: string,
        private _searchMode: string,
        private _maxFeatureCount: number,
        public printOptions: IPrintOptions,
        mappingTextPack: IMappingTextPack,
        user:HbsmrUser)
    {
        super(mappingTextPack, user);
        this.init();
    }

    private init = () => {
        if (this.initialised) {
            return;
        }
                
        this.layerConfigFactory = new DefaultLayerConfigurationFactory();
        this.vectorLayerGroupFactory = new VectorLayerGroupFactory();
        this.layerGroupFactory = new LayerGroupFactory(this.vectorLayerGroupFactory, null);
        this.mapFilter = new MapFilters();
        this.mapFilter.OgcFilter = new OgcMapFilter();
        this.baseLayerFactory = new NorthantsBaseMapping_3857();
        this.featureLoader = new GeoJsonFeatureLoader();

        this.featureAdd = new FeatureAddSmallGeomsAsPoint(4.5);        

        this.mapFactory = new MapFactory();
        this.logger = new Logger();
        this.boundsLoaderBehaviour = new BoundsLoaderExtentsBehaviour(this.logger);
        this.styleFactory = new HbsmrStyleFactory();
        this.resourcefactory = new HbsmrResourcefactory(this.mappingTextPack);

        this.mfOptions = DefaultMapOptions.GetDefaultOptions(this._mapElementId, "SearchMap3857");
        this.mfOptions.enableBoundsTracking = false;
        // zoom & centre determines the starting bounds of the map. Must be big enough to fit the whole area
        this.mfOptions.mapZoom = 9;
            
        this.layerGroups = this.layerGroupFactory.getLayerGroups(this.getLayerGroupConfig(), this.styleFactory);
        this.mfOptions.layerGroupCollection = this.layerGroups;

        this.mapStore = new MapViewStore(this.mfOptions.mapStoreKey);
        this.herMask = new NorthantsHerBoundary();
        this.mapContextMenu = new MapContextMenu(this.mappingTextPack);
        this.vectorLayerSourceFactory = new VectorLayerSourceFactory(this.logger, this.boundsLoaderBehaviour, this.featureLoader, this.featureAdd);
        this.map = this.mapFactory.instance(this.mfOptions, this.mapStore, this.logger, this.vectorLayerSourceFactory, this.baseLayerFactory, this.boundsLoaderBehaviour, this.mapContextMenu, this.printOptions, this.mapFilter, this.mappingTextPack);
        this.map.olMap.addLayer(this.herMask.getMask());
        this.infoPopup = new MapFeatureInfo(this.map, this.resourcefactory.getRecordTypeResource(), this.mappingTextPack);
        let overlays = new CustomMapLayerSwitcherOverlays(this.map, this.mapStore, this.layerGroups, this.mappingTextPack);
        this.ls = new MapLayerSwitcher(this.map, this.mapStore, this.styleFactory, this.map.baseLayers, this.layerGroups, this.mappingTextPack, overlays, {
            showList: false,
            showOpenPanelByDefault: !this.printOptions.isPrintMap,
            rememberActivePanel: true
        });
        //this.osOpenNames = new OsOpenNames(this.map, "{clientKey}", this.mappingTextPack, 10);
        this.geoNames = new GeoNames(this.map, this.mappingTextPack, 13);
        this.geoNames.locationPinStyle = new Style({
            text: new TextStyle({
                text: '\uf3c5',
                font: 'normal 52px "Font Awesome 6 Pro"',
                textBaseline: 'bottom',
                fill: new Fill({
                    color: '#ff0000'
                })
            })
        }); 

        if (this.printOptions.isPrintMap) {
            this.printOptions.setMap(this.map);
        }
        this.downloadPng = new DownloadMapPng(this.map, this.mappingTextPack);
        this.gridRefFinder = new GridRef(this.map, this.mappingTextPack, this.logger);
        this.extentsNavigation = new ExtentsNavigation(this.map, this.logger, this.mappingTextPack);
        this.mousePosition = new MousePosition(this.map, this.mappingTextPack);

        if (!('ontouchstart' in window && navigator.maxTouchPoints > 0)) {
            //add tooltip if not touch
            this.mapToolTip = new MapToolTip(this.map, new ToolTipProvider(), new ToolTipOptions(7));
        }

        this.initialised = true;
    }

    private getLayerGroupConfig = (): Array<IlayerGroupCollectionConfig> => {
        let self = this;
        let layerGroupConfig: Array<IVectorLayerGroupConfig> = [
            {
                type: NorthamptonshireRecordType.Monument,
                displayName: 'Monuments <i class="fas fa-filter"></i>',
                strategy: VectorLayerStrategy.Bbox,
                url: "/api/OgcService/hbsmr",
                wfsParams: new WfsParamSourceMapServer(null, { srsName: "EPSG:27700" }),
                legend: { point: false, line: false },
                zoomToDataBounds: ZoomToDataBounds.Always,
                allowZoomToLoadedDataBounds : true,
                alwaysLoadOnZoom: false,
                //maxFeatureCount: this._maxFeatureCount,  
                maxFeatureCount: 10000, // allow lots!
                urlParams: {
                    searchstring: this._searchString,
                    searchmode: this._searchMode
                },                
                layers: [
                    {
                        layerName: "MonumentPolygonsWFS_Search",
                        minZoom: 7,
                        maxZoom: 19
                    },
                    {
                        layerName: "MonumentLinesWFS_Search",
                        minZoom: 7,
                        maxZoom: 19
                    },
                    {
                        layerName: "MonumentPointsWFS_Search",
                        minZoom: 1,
                        maxZoom: 19
                    },
                    {
                        layerName: "MonumentLinesAsPointsWFS_Search",
                        minZoom: 1,
                        maxZoom: 6
                    },
                    {
                        layerName: "MonumentPolygonsAsPointsWFS_Search",
                        minZoom: 1,
                        maxZoom: 6
                    }
                ]
            },            
            self.layerConfigFactory.layerConfig(NorthamptonshireRecordType.Event),   
            self.layerConfigFactory.layerConfig(NorthamptonshireRecordType.Designation, NorthamptonshireRecordSubType.ScheduledMonument),                                 
            self.layerConfigFactory.layerConfig(NorthamptonshireRecordType.Designation, NorthamptonshireRecordSubType.ListedBuilding),
            self.layerConfigFactory.layerConfig(NorthamptonshireRecordType.Designation, NorthamptonshireRecordSubType.LocallyListedBuilding),
            self.layerConfigFactory.layerConfig(NorthamptonshireRecordType.Designation, NorthamptonshireRecordSubType.ConservationArea),
            self.layerConfigFactory.layerConfig(NorthamptonshireRecordType.Designation, NorthamptonshireRecordSubType.RegisteredParksAndGardens),
            self.layerConfigFactory.layerConfig(NorthamptonshireRecordType.Designation, NorthamptonshireRecordSubType.RegisteredBattlefields)            
        ];
        return [
            {
                ref: "all_layers",
                name: "All layers",
                useAccordion: false,
                expandedOnFirstLoad: true,
                layerGroupConfigs: this.filterMapLayers(layerGroupConfig)
            }
        ];
    }       

}